import {ApiUrls} from 'shared/config/model/urls';

import {useDispatch} from 'react-redux';

import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';
import {
    buildDomainBatchOperationRequest,
    DomainBatchOperationsFormValues,
    getDomainBatchOperationsDefaults,
} from 'features/domain/lib/domainMonitorFormHelper';
import {useMonitorBatchOperationsForm, IMonitorBatchOperationsFormState, isBatchDeleteAction} from 'entities/monitor';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

import {useDomainMonitorSelection} from './useDomainMonitorSelection';

interface IUseDomainMonitorBatchOperationsFormParams {
    actionValue?: string,
    handleClose: () => void,
    onSuccess?: () => void,
}

export const useDomainMonitorBatchOperationsForm = ({
    actionValue,
    handleClose,
    onSuccess,
}: IUseDomainMonitorBatchOperationsFormParams): IMonitorBatchOperationsFormState<DomainBatchOperationsFormValues> => {
    const {selectedIds} = useDomainMonitorSelection();
    const dispatch = useDispatch<TypedDispatch>();

    const invalidate = (action: string | undefined, ids: string[]) => {
        if (action === 'export') {
            return;
        }

        dispatch(domainMonitorAPI.util.invalidateTags([{type: 'DomainMonitor', id: 'LIST'}, 'SummaryDomainMonitors']));

        if (!isBatchDeleteAction(action)) {
            ids.forEach(uuid => {
                dispatch(domainMonitorAPI.util.invalidateTags([{type: 'DomainMonitor', id: uuid}]));
            });
        }

        if (action !== 'tags') {
            dispatch(domainIncidentAPI.util.invalidateTags(['DomainIncident', 'SummaryDomainIncident']));
        }

        dispatch(fetchMe());
    };

    return useMonitorBatchOperationsForm<DomainBatchOperationsFormValues>({
        actionValue,
        handleClose,
        onSuccess,
        selectedIds,
        getDefaultValues: getDomainBatchOperationsDefaults,
        getUrl: (action) => action === 'export'
            ? ApiUrls.DOMAIN_MONITORS_EXPORT
            : ApiUrls.DOMAIN_MONITORS_BATCH_ACTION(action ?? ''),
        buildRequest: buildDomainBatchOperationRequest,
        invalidate,
    });
};

export default useDomainMonitorBatchOperationsForm;
